import { render } from "./aluno-basic-info.vue?vue&type=template&id=34274c8c"
import script from "./aluno-basic-info.vue?vue&type=script&lang=js"
export * from "./aluno-basic-info.vue?vue&type=script&lang=js"

import "./aluno-basic-info.vue?vue&type=style&index=0&id=34274c8c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__